import React from 'react';
import { Grid, TextField, MenuItem, Autocomplete, Typography } from '@mui/material';
import { opOptions, diagnosisOptions, procedureOptions } from '../constants/options';

const BasicInfoSection = ({ formData, handleChange, handleNameChange, setFormData, errors, handleBlur }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField fullWidth InputProps={{ readOnly: true }} label="Name" value={formData.name || ''} required onChange={handleNameChange} name="name" />
      </Grid>
      <Grid item xs={6}>
        <TextField InputProps={{ readOnly: true }} fullWidth label="Age" value={formData.age || ''} required onChange={handleChange("age")} type="number" />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Sex"
          value={formData.sex || ''}
          InputProps={{ readOnly: true }}
          onChange={handleChange("sex")}
          required
          select
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          freeSolo
          options={opOptions.map(String)}
          value={formData.op_no || ''}
          onInputChange={(event, newValue) => {
            setFormData(prev => ({ ...prev, op_no: newValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Op" type="number" fullWidth variant="outlined" />}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField fullWidth label=" IP No" InputProps={{ readOnly: true }} value={formData.ip_no || ''} onChange={handleChange("ip_no")} required type="number" />
      </Grid>
      <Grid item xs={6}>
        <TextField fullWidth label="UHID No" value={formData.uhid_no || ''} onChange={handleChange("uhid_no")} required InputProps={{ readOnly: true }} type="number" />
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          freeSolo
          options={diagnosisOptions}
          value={formData.pre_op_diagnosis || ''}
          onInputChange={(event, newValue) => {
            setFormData(prev => ({ ...prev, pre_op_diagnosis: newValue }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={<span>Pre-Op Diagnosis <span style={{ color: 'red' }}>*</span></span>}
              fullWidth
              variant="outlined"
              name="pre_op_diagnosis"
              error={!!errors.pre_op_diagnosis}
              helperText={errors.pre_op_diagnosis}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          freeSolo
          options={procedureOptions}
          value={formData.proposed_procedure || ''}
          onInputChange={(event, newValue) => {
            setFormData(prev => ({ ...prev, proposed_procedure: newValue }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={<span>Proposed Procedure <span style={{ color: 'red' }}>*</span></span>}
              fullWidth
              variant="outlined"
              name="proposed_procedure"
              error={!!errors.proposed_procedure}
              helperText={errors.proposed_procedure}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography>Date & Time <span style={{ color: 'red' }}>*</span></Typography>
        <TextField
          type="datetime-local"
          inputProps={{ min: new Date().toISOString().slice(0, 16) }}
          fullWidth
          value={formData.proposed_date_time || ''}
          required
          onChange={handleChange("proposed_date_time")}
          name="proposed_date_time"
          error={!!errors.proposed_date_time}
          helperText={errors.proposed_date_time}
          onBlur={handleBlur}
        />
      </Grid>
    </Grid>
  );
};

export default BasicInfoSection;
